export default "__VITE_ASSET__BgMnHkFK__"